import React, { useState } from 'react';
import TemplateModern from '../templates/TemplateModern';
import TemplateClassic from '../templates/TemplateClassic';
import TemplateMinimal from '../templates/TemplateMinimal';
import { Layers } from 'lucide-react';

const dummyData = {
  invoice: {
    invoiceNo: 'DEMO-26-041300001',
    invoiceDate: new Date().toISOString(),
    billerCompany: 'Sample Corp',
    billerAddress: '123 Business Avenue, City',
    billerContact: 'info@sample.com',
    billerGSTIN: '00SAMPLE000GSTIN',
    billToCompany: 'Demo Client',
    billToName: 'John Doe',
    billToAddress: '456 Client St, City',
    billToGSTIN: '11CLIENT111GSTIN',
    subTotal: 5000,
    totalCGST: 450,
    totalSGST: 450,
    grandTotal: 5900
  },
  items: [
    { description: 'Premium Web Design Services', hsnSacCode: '9983', qty: 1, netPrice: 3000, gstPercentage: 18, totalItemPrice: 3540 },
    { description: 'Server Maintenance', hsnSacCode: '9983', qty: 1, netPrice: 2000, gstPercentage: 18, totalItemPrice: 2360 }
  ],
  payments: [
    { transactionDate: new Date().toISOString(), transactionDesc: 'Advance Payment', modeOfPayment: 'Bank Transfer', transactionId: 'TXN123456', amount: 5900 }
  ]
};

const TemplateGallery = () => {
  const [activePreview, setActivePreview] = useState('TemplateModern');

  return (
    <div className="form-section animate-fade-in">
      <h3 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Layers size={20} className="text-primary"/> Template Gallery
      </h3>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
        <button 
          onClick={() => setActivePreview('TemplateModern')} 
          className={`btn-outline ${activePreview === 'TemplateModern' ? 'active-tab' : ''}`}
          style={{ background: activePreview === 'TemplateModern' ? 'var(--primary)' : 'transparent', color: activePreview === 'TemplateModern' ? 'white' : 'var(--primary)' }}
        >
          Modern Blue
        </button>
        <button 
          onClick={() => setActivePreview('TemplateClassic')} 
          className={`btn-outline ${activePreview === 'TemplateClassic' ? 'active-tab' : ''}`}
          style={{ background: activePreview === 'TemplateClassic' ? 'var(--primary)' : 'transparent', color: activePreview === 'TemplateClassic' ? 'white' : 'var(--primary)' }}
        >
          Classic Professional
        </button>
        <button 
          onClick={() => setActivePreview('TemplateMinimal')} 
          className={`btn-outline ${activePreview === 'TemplateMinimal' ? 'active-tab' : ''}`}
          style={{ background: activePreview === 'TemplateMinimal' ? 'var(--primary)' : 'transparent', color: activePreview === 'TemplateMinimal' ? 'white' : 'var(--primary)' }}
        >
          Minimal Print
        </button>
      </div>

      <div style={{ border: '1px solid var(--border-color)', borderRadius: '8px', padding: '1rem', background: '#F8FAFC' }}>
        <h4 style={{ textAlign: 'center', marginBottom: '1rem', color: 'var(--text-muted)' }}>Previewing: {activePreview}</h4>
        <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
          {activePreview === 'TemplateModern' && <TemplateModern data={dummyData} />}
          {activePreview === 'TemplateClassic' && <TemplateClassic data={dummyData} />}
          {activePreview === 'TemplateMinimal' && <TemplateMinimal data={dummyData} />}
        </div>
      </div>
    </div>
  );
};

export default TemplateGallery;
